// SmartFitBounds.jsx
import { useEffect, useMemo, useRef } from "react";
import { useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";

/**
 * points가 바뀌어도, firstOnly=true면 최초 1회만 fit.
 * 사용자 최근 조작(coolDownMs 내)이 있으면 fit 생략.
 */
export default function SmartFitBounds({
  points = [],
  pad = 0.1,
  enabled = true,
  firstOnly = true,
  coolDownMs = 1500,
}) {
  const map = useMap();
  const didFitOnceRef = useRef(false);
  const lastTouchRef = useRef(0);

  useMapEvents({
    movestart() { lastTouchRef.current = Date.now(); },
    zoomstart() { lastTouchRef.current = Date.now(); },
  });

  const bounds = useMemo(() => {
    const pts = (points || []).filter(Boolean);
    if (!pts.length) return null;
    try {
      const b = L.latLngBounds(pts);
      return b.isValid() ? b : null;
    } catch {
      return null;
    }
  }, [points]);

  useEffect(() => {
    if (!enabled || !bounds) return;
    if (firstOnly && didFitOnceRef.current) return;
    const since = Date.now() - lastTouchRef.current;
    if (since < coolDownMs) return;

    map.fitBounds(bounds.pad(pad));
    didFitOnceRef.current = true;
  }, [enabled, firstOnly, bounds, pad, map, coolDownMs]);

  return null;
}
